<template>
  <v-col
    cols="12"
  >
    <v-row>
      <v-col
        cols="6"
        class="text-field-url"
      >
        <v-text-field
          v-model="commandUrl"
          :label="$t('components.config.ConfigContract.label.commandUrl')"
        />
      </v-col>
      <v-row
        no-gutters
      >
        <CopyToClipboard
          :content="commandUrl"
        />
      </v-row>
    </v-row>
    <v-row>
      <v-col
        cols="6"
        class="text-field-url"
      >
        <v-text-field
          v-model="botKey"
          :label="$t('components.config.ConfigContract.label.botKey')"
        />
      </v-col>
      <v-row
        no-gutters
      >
        <CopyToClipboard
          :content="botKey"
        />
      </v-row>
    </v-row>

    <DsButton
      class="mt-5"
      @click="save"
    >
      {{ $t('components.config.ConfigContract.button.save') }}
    </DsButton>
  </v-col>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import CopyToClipboard from '@/components/CopyToClipboard';
import { DsButton } from '@ds/components';
import { MUTATE } from '@/store/modules/mutation_types';

export default {
  name: 'ConfigContract',
  components: {
    CopyToClipboard,
    DsButton,
  },
  data() {
    return {
      botKey: '',
      commandUrl: '',
    };
  },
  computed: {
    ...mapGetters('dashboard', [
      'getCommandUrl',
      'getBotKey',
    ]),
  },
  mounted() {
    this.botKey = this.getBotKey || '';
    this.commandUrl = this.getCommandUrl || '';
  },
  methods: {
    ...mapActions('dashboard', [
      'saveContractInfo',
    ]),
    ...mapMutations('misc', {
      mutateMisc: MUTATE,
    }),
    save() {
      const contracts = {
        key: this.botKey,
        commandUrl: this.commandUrl,
      };

      this.saveContractInfo(contracts).then(() => {
        this.$noty.success(this.$t('components.config.ConfigContract.message.success'));

        this.mutateMisc({
          property: 'showConfig',
          with: false,
        });
      }, (err) => {
        const errorMessage = this.$t('components.config.ConfigContract.message.error');
        console.error(errorMessage, err);
        this.$noty.error(errorMessage);
      });
    },
  },
};
</script>

<style scoped>
</style>
